import restAPI from '@/utils/rest-api'

export default {
    fetchPromoLink(offerId) {
        return restAPI.get(`/promo-links/offer/${offerId}`)
    }
}
